<template>
  <div class="content">
    <div class="header">应用中心</div>
    <div class="cont" id="cont">
      <div class="platform">
        <div class="title">平台型应用</div>
        <div class="box">
          <el-card
            :body-style="{ padding: '0px' }"
            shadow="hover"
            v-for="(item, index) in platformData"
            :key="index"
            class="list"
          >
            <img
              :src="item.name"
              alt
              style="width:100%"
              @click="clickView(item.index)"
            />
          </el-card>
        </div>
      </div>
      <div class="marketing">
        <div class="title">营销型应用</div>
        <div class="box">
          <el-card
            :body-style="{ padding: '0px' }"
            shadow="hover"
            v-for="(item, index) in marketingData"
            :key="index"
            class="list"
          >
            <img
              :src="item.name"
              alt
              style="width:100%"
              @click="clickView(item.index)"
            />
          </el-card>
        </div>
      </div>
    </div>
    <!-- 切换具体的显示块 -->
    <!-- <el-button type="primary">拼团</el-button>
    <el-button type="primary" ../../click="toshop">商城</el-button>-->
  </div>
</template>

<script>
export default {
  data() {
    return {
      is_show: 0,
      platformData: [
        {
          index: 1,
          name: require("../../../public/img/dianshang.png")
        },
        {
          index: 2,
          name: require("../../../public/img/dianshang.png")
        },
        {
          index: 3,
          name: require("../../../public/img/zdyzhuti.png")
        },
        {
          index: 12,
          name: require("../../../public/img/duoshanghu.png")
        },
        {
          index: 13,
          name: require("../../../public/img/huiyuanxitong.png")
        },
        {
          index: 15,
          name: require("../../../public/img/mendian.png")
        },
        {
          index: 16,
          name: require("../../../public/img/yuangongguanli.png")
        },
        {
          index: 17,
          name: require("../../../public/img/jifenshezhi.png")
        },
        {
          index: 18,
          name: require("../../../public/img/luntan.png")
        }
      ],
      marketingData: [
        {
          index: 4,
          name: require("../../../public/img/tuangou.png")
        },
        {
          index: 5,
          name: require("../../../public/img/kanjia.png")
        },
        {
          index: 6,
          name: require("../../../public/img/zhuli.png")
        },
        {
          index: 7,
          name: require("../../../public/img/qiandao.png")
        },
        {
          index: 8,
          name: require("../../../public/img/qianggou.png")
        },
        {
          index: 9,
          name: require("../../../public/img/youhuiquan.png")
        },
        {
          index: 10,
          name: require("../../../public/img/fenxiao.png")
        },
        {
          index: 11,
          name: require("../../../public/img/pintaun.png")
        },
        {
          index: 14,
          name: require("../../../public/img/jifenShop.png")
        },
        {
          index: 19,
          name: require("../../../public/img/youhuishezhi@2x.png")
        },
        {
          // 满减活动
          index: 20,
          name: require("../../../public/img/manjian@2x.png")
        },
        {
          // 满包邮活动
          index: 21,
          name: require("../../../public/img/manbaoyou@2x.png")
        },
        {
          // 满包邮活动
          index: 22,
          name: require("../../../public/img/zhuanpanchoujiang.png")
        }
      ]
    };
  },
  mounted() {},
  methods: {
    chageview(index) {
      this.is_show = index;
    },
    clickView(index) {
      console.log(index);
      // 公用一个导航组件itemFrame  ->class 区别
      switch (index) {
        case 2:
          this.$router.push({
            path: "mallManagement"
          });
          break;
        case 4:
          this.$router.push({
            path: "GoodsGroup/4"
          });
          break;
        case 12: {
          this.$router.push("merchants/12");
          break;
        }
        case 13: {
          this.$router.push({
            // path: "vip",
            path: "newVip/13"
          });
          break;
        }
        case 14:
          this.$router.push("integralMall/14");
          break;
        case 7:
          this.$router.push("sign/7");
          break;
        case 9:
          this.$router.push("coupon/9");
          break;
        case 10:
          this.$router.push("distribute/10");
          break;
        case 15:
          this.$router.push("storeManage/15");
          break;
        case 16:
          this.$router.push("employee/16");
          break;
        case 17:
          this.$router.push("point/17");
          break;
        case 18:
          this.$router.push("forum/18");
          break;
        case 19:
          this.$router.push("couponSetting/19");
          break;
        case 20:
          this.$router.push("fullReduction/20");
          break;
        case 21:
          this.$router.push("fullPackage/21");
          break;
        case 22:
          this.$router.push("luckyDraw/22");
          break;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.content {
  padding: 0px 40px;
  height: 100%;
  background: rgba(248, 250, 255, 1);
  .header {
    width: 100%;
    height: 95px;
    line-height: 95px;
    font-weight: 800;
    font-size: 20px;
  }
  .cont {
    .title {
      height: 56px;
      line-height: 56px;
      font-size: 16px;
      font-weight: 550;
    }
    .box {
      display: flex;
      flex-wrap: wrap;
      .el-card {
        border: none;
        margin: 20px;
      }
      .list {
        width: 98px;
        height: 98px;
      }
      .current {
        box-shadow: 3px 3px 6px 0px rgba(0, 0, 0, 0.07);
      }
    }
    .platform {
      width: 100%;
      background: rgba(255, 255, 255, 1);
      border-radius: 3px;
    }
    .marketing {
      width: 100%;
      margin-top: 20px;
      background: rgba(255, 255, 255, 1);
    }
  }
}
</style>
